import { useNotification } from '@faceup/ui-base'
import { useEffect } from 'react'

export const useComponentDidMount = (fn: () => void | Promise<void>) => {
  const notification = useNotification()
  // biome-ignore lint/correctness/useExhaustiveDependencies: Intentionally run only on mount, not when fn changes
  useEffect(() => {
    // TODO: validate if this try catch is working well?
    const main = async () => {
      try {
        await fn()
      } catch (err) {
        console.error(err)

        notification.error({
          message: 'Init error',
          description: err?.toString(),
        })

        throw err
      }
    }

    main()
  }, [])
}
